module.exports = __webpack_public_path__ + "static/img/SmartPlatform3.ff41c3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/SmartPlatform3.png
// module id = xVkG
// module chunks = 13